import XIcon from "assets/icons/XIcon";

import styles from "./style.module.scss";

interface SelectionAlertModalProps {
  icon?: JSX.Element;
  title: JSX.Element;
  content: JSX.Element;
  onAccept: () => void;
  onDecline: () => void;
}

const SelectionAlertModal = ({
  title,
  content,
  icon = <noscript />,
  onAccept,
  onDecline,
}: SelectionAlertModalProps) => {
  return (
    <div className={styles.overlay} onClick={(e) => e.stopPropagation()}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <div className={styles.titleContainer}>
            {icon}
            {title}
          </div>

          <span onClick={onDecline} className={styles.crossIcon}>
            <XIcon />
          </span>
        </div>

        <span className={styles.divider} />

        <div className={styles.content}>{content}</div>

        <span className={styles.divider} />

        <div className={styles.buttonContainer}>
          <div className={styles.cancelButton} onClick={onDecline}>
            Cancel
          </div>
          <div className={styles.confirmButton} onClick={onAccept}>
            Continue
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectionAlertModal;
